// Copyright (c) 2023 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateTemporaryObjectKey = (state, action) =>
    action.temporaryObjectKey;

export default (state = getDefaultState().temporaryObjectKey, action) => {

    const actionTypes = {
        [actions.UPDATE_DUPLICATE_PIN_PLATE_TEMPORARY_OBJECT_KEY]: updateTemporaryObjectKey
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/reducers/temporary-object-key.js